import { SortDto } from './sort.dto';

export class PageDto<T> {
  content: T[] = [];
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  sort: SortDto[] = [];
  totalElements: number;
  totalPages: number;

  constructor(d?: PageDto<T>) {
    if (!d) {
      return;
    }
    Object.assign(this, d || {});
    this.content = d.content || [];
  }
}
